import React from 'react';
import t from '~t';
import withEdit from '~co/user/withEdit';

import { Modal, ModalHeader as Header, Layout, Label, Input, Button, ButtonRow } from '~ui';

function SettingsAccountProfilePassword({
  newpassword = '',
  oldpassword = '',
  status,
  onChange,
  onClose,
  onSubmit,
}) {
  return (
    <Modal className='w-110' onClose={onClose}>
      <Header title={t.s('changePassword')} />

      <form
        onSubmit={(e) => {
          e.preventDefault();
          e.stopPropagation();
          onSubmit(onClose);
        }}
      >
        <Layout>
          <Label>{t.s('currentPassword')}</Label>
          <Input
            autoFocus
            required
            type='password'
            disabled={status == 'loading'}
            name='oldpassword'
            value={oldpassword}
            onChange={onChange}
          />

          <Label>{t.s('newPassword')}</Label>
          <Input
            required
            type='password'
            disabled={status == 'loading'}
            name='newpassword'
            value={newpassword}
            onChange={onChange}
          />

          <ButtonRow>
            <Button
              type='submit'
              disabled={
                !oldpassword || !newpassword || status == 'loading'
              }
              variant='default'
            >
              {t.s('changePassword')}
            </Button>

            <Button variant='outline' onClick={onClose}>
              {t.s('cancel')}
            </Button>
          </ButtonRow>
        </Layout>
      </form>
    </Modal>
  );
}

export default withEdit(SettingsAccountProfilePassword, [
  'newpassword',
  'oldpassword',
]);
